import {load} from '@shopify/theme-sections';
import '../sections/product';
import React from 'react';
import ReactDOM from 'react-dom';
import Consultant from '../components/Consultant';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  const tradeUpProducts = document.querySelectorAll('[data-trade-up-product]');

  if (tradeUpProducts.length > 0) {
    const tradeUpSelected = document.querySelector('.trade-up__product--selected');
    const tradeUpInput = document.querySelector('[name="properties[Trade up]"]');

    if (tradeUpSelected && tradeUpInput) {
      const tradeUpSelectedTitle = tradeUpSelected.dataset.tradeUpProduct;
      if (tradeUpSelectedTitle) {
        tradeUpInput.value = tradeUpSelectedTitle;
      }
    }

    tradeUpProducts.forEach(item => {
      item.addEventListener('click', () => {
        tradeUpProducts.forEach(item => item.classList.remove('trade-up__product--selected'));
        item.classList.add('trade-up__product--selected');
        const title = item.dataset.tradeUpProduct;
        if (!title || !tradeUpInput) return;
        tradeUpInput.value = title;
      });
    });
  }

  const $consultantContainers = document.querySelectorAll('[data-consultant]');

  $consultantContainers.forEach($consultantContainer => {
    if ($consultantContainer.hasAttribute('data-side-cart-consultant')) {
      ReactDOM.render(<Consultant openAssignConsultant={false} cancelPromptWhenAssigning={false} />, $consultantContainer);
    } else {
      ReactDOM.render(<Consultant openAssignConsultant={true} cancelPromptWhenAssigning={false} />, $consultantContainer);
    }
  });
});
